import Swiper from 'swiper';
import { Navigation, FreeMode, Mousewheel } from 'swiper/modules';
import { MOBILE } from '../../assets/scripts/constants';

class ProductRecomended {
	constructor(el) {
		this.container = el;

		if (!this.container) return;

		this.init();
	}

	init() {
		const sliderContainer = this.container.querySelectorAll('[data-product-recomended-swiper]');

		if (!sliderContainer) return;

		sliderContainer.forEach((slider) => {
			const next = slider.querySelector('.product-recomended__nav-button._next');
			const prev = slider.querySelector('.product-recomended__nav-button._prev');
			const nav = slider.querySelector('.product-recomended__nav');

			// Предотвращаем перетаскивание кнопок навигации
			[next, prev].forEach((button) => {
				if (!button) return;

				// Предотвращаем drag события
				button.addEventListener('dragstart', (e) => {
					e.preventDefault();
					e.stopPropagation();
					return false;
				});

				// Предотвращаем распространение pointer событий к слайдеру
				button.addEventListener('mousedown', (e) => {
					e.stopPropagation();
				});

				button.addEventListener('touchstart', (e) => {
					e.stopPropagation();
				});
			});

			const HIDE_NEXT_BUTTON_THRESHOLD = 1;

			const checkNextButton = (swiperInstance) => {
				const totalSlides = swiperInstance.slides.length;
				const currentIndex = swiperInstance.activeIndex;
				const slidesPerGroup = swiperInstance.params.slidesPerGroup;
				const remainingSlides = totalSlides - currentIndex - slidesPerGroup;

				if (remainingSlides <= HIDE_NEXT_BUTTON_THRESHOLD) {
					next.setAttribute('disabled', '');
				} else {
					next.removeAttribute('disabled');
				}
			};

			const updateArrowOffset = (swiperInstance) => {
				if (!nav || !slider) return;

				const firstSlide = swiperInstance.slides[swiperInstance.activeIndex];
				if (!firstSlide) return;

				const cardImage = firstSlide.querySelector('.card__image');
				if (!cardImage) return;

				const cardImageHeight = cardImage.offsetHeight;
				const swiperHeight = swiperInstance.height;

				if (swiperHeight > 0 && cardImageHeight > 0) {
					// Вычисляем смещение стрелки, чтобы она была по центру изображения карточки
					// Центр изображения относительно swiper: (cardImageHeight / 2)
					// Центр nav (который теперь 100% высоты): (swiperHeight / 2)
					// Смещение = центр изображения - центр nav
					const arrowOffset = cardImageHeight / 2 - swiperHeight / 2;
					nav.style.setProperty('--arrow-offset', `${arrowOffset}px`);
				}
			};

			const mm = window.matchMedia(MOBILE);
			let swiper = null;

			const onMMChange = () => {
				if (mm.matches) {
					if (swiper) {
						swiper.destroy(true, true);
						swiper = null;
					}
				} else {
					swiper = new Swiper(slider, {
						spaceBetween: 1,
						slidesPerView: 2,
						slidesPerGroup: 2,
						speed: 600,
						observer: true,
						observeParents: true,
						modules: [Navigation, FreeMode, Mousewheel],
						navigation: {
							nextEl: next,
							prevEl: prev,
						},
						freeMode: true,
						mousewheel: {
							forceToAxis: true,
							releaseOnEdges: true,
							sensitivity: 1,
						},
						breakpoints: {
							768: {
								slidesPerView: 3.33,
								slidesPerGroup: 3,
								spaceBetween: 4,
								freeMode: {
									enabled: true,
									sticky: false,
									momentumRatio: 0.4,
									momentumBounce: false,
									momentumVelocityRatio: 0.4,
								},
							},
							1280: {
								slidesPerView: 4.5,
								slidesPerGroup: 4,
								spaceBetween: 1,
								freeMode: {
									enabled: true,
									sticky: false,
									momentumRatio: 0.4,
									momentumBounce: false,
									momentumVelocityRatio: 0.4,
								},
							},
							1920: {
								slidesPerView: 6.02,
								slidesPerGroup: 6,
								spaceBetween: 1,
								freeMode: {
									enabled: true,
									sticky: false,
									momentumRatio: 0.4,
									momentumBounce: false,
									momentumVelocityRatio: 0.4,
								},
							},
						},
						on: {
							init: function () {
								checkNextButton(this);
								setTimeout(() => {
									updateArrowOffset(this);
								}, 100);
							},
							slideChange: function () {
								checkNextButton(this);
							},
							resize: function () {
								checkNextButton(this);
								updateArrowOffset(this);
							},
							slideChangeTransitionEnd: function () {
								updateArrowOffset(this);
							},
						},
					});
				}
			};

			onMMChange();
			mm.addEventListener('change', onMMChange);
		});
	}
}

document.querySelectorAll('[data-product-recomended]').forEach((el) => new ProductRecomended(el));
export default ProductRecomended;
